// extracted by mini-css-extract-plugin
module.exports = {"photoPost":"UserPhotoPost_photoPost__2Yuyl","file":"UserPhotoPost_file__2A313","preview":"UserPhotoPost_preview__1Ph2R"};